/* eslint-disable indent */
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Starter from "../../../component/Starter";
import Card from "../../../component/card/Card";
import Strong from "../../../component/smallComponents/Strong";
import P from "../../../component/smallComponents/P";
import HeaderTag from "../../../component/smallComponents/HeaderTag";
import SelectInput from "../../../component/input/SelectInput";
import TextInput from "../../../component/input/TextInput";
import TextArea from "../../../component/input/TextArea";
import {
  getBrowserDetails,
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction
} from "../../../constant/helper/helper";
import SpinnerButton from "../../../component/spinner/SpinnerButton";
import Button from "../../../component/button/Button";
import { CREATED_AS_TYPE } from "../../../constant/constant";
import { attendanceActions } from "../../../redux/actions";
import { helperFunction } from "../../../constant/helper";
import isEmpty from "../../../validation/isEmpty";

function SingleMissing() {
  const loginType = localStorage.loginType;

  const dispatch = useDispatch();
  const [date, setDate] = useState("");
  const [date2, setDate2] = useState("");
  const [isOd, setIsOd] = useState(false);
  const [allLocations, setAllLocations] = useState([]);
  const [selectLocation, setSelectLocation] = useState("");
  const [attendanceData, setAttendanceData] = useState({
    workerId: "",
    inTime: "",
    outTime: "",
    present: "YES",
    remark: "",
    status: ""
  });
  const shiftType = "FIRST / GENERAL SHIFT";
  const sameDayOut = "NO";
  const twentyFour = false;

  const { currentUser } = useSelector((state) => state.auth);
  const { locations } = useSelector((state) => state.location);
  const {
    attendanceError,
    attendanceLoading,
    attendanceResponse
  } = useSelector((state) => state.attendance);

  useEffect(() => {
    setAllLocations(locations);
  }, [locations]);

  useEffect(() => {
    if (!isEmpty(attendanceError)) {
      helperFunction.toastHelper("error", attendanceError);
    }
  }, [attendanceError]);

  useEffect(() => {
    if (!isEmpty(attendanceResponse)) {
      helperFunction.toastHelper("success", attendanceResponse);
    }
  }, [attendanceResponse]);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setAttendanceData({
      ...attendanceData,
      [name]: value
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    const browserDetail = await getBrowserDetails();
    const os = browserDetail.os.name;
    const browser = browserDetail.browser.name;

    const attendanceRegularizedData = {
      isOd,
      date,
      date2,
      shiftType,
      sameDayOut,
      twentyFour,
      locationId: selectLocation,
      inTime: attendanceData.inTime,
      remark: attendanceData.remark,
      status: attendanceData.status,
      outTime: attendanceData.outTime,
      present: attendanceData.present,
      workerId: attendanceData.workerId,
      ipAddress: localStorage?.publicIpAdd,
      deviceDetails: os + "-" + browser,
      latitude: localStorage.latitude,
      longitude: localStorage.longitude
    };

    dispatch(attendanceActions.setAttendanceLoading(true));
    dispatch(attendanceActions.clearAttendanceErrors());
    dispatch(attendanceActions.clearAttendanceResult());
    dispatch(
      attendanceActions.addSingleMissingAttendance(
        attendanceRegularizedData,
        loginType
      )
    );
  };

  const topInput = (
    <form onSubmit={onSubmit}>
      <div className="row mb-2">
        <div className="col-md-3 mt-3 col-xl-3 col-lg-3">
          <TextInput
            type="date"
            name="date"
            label="Date"
            value={date}
            htmlFor="date"
            required={true}
            textWhite={false}
            placeholder="Enter date"
            onChange={(e) => setDate(e.target.value)}
          />
        </div>
        {twentyFour === "true" && (
          <div className="col-md-3 mt-3 col-xl-3 col-lg-3">
            <TextInput
              type="date"
              name="date2"
              value={date2}
              htmlFor="date2"
              required={true}
              textWhite={false}
              label="Second Date"
              placeholder="Enter Second Date"
              onChange={(e) => setDate2(e.target.value)}
            />
          </div>
        )}
        <div className="col-md-3 mt-3 col-xl-3 col-lg-3">
          <SelectInput
            required={true}
            name="location"
            textWhite={false}
            isLabeled={false}
            value={selectLocation}
            label="Select Location"
            onChange={(e) => setSelectLocation(e.target.value)}
          >
            <option value=""> Select Location</option>
            {isSuperAdmin(currentUser)
              ? renderLocationFunction(allLocations)
              : renderAccessLocation2(
                  locationRender(currentUser, false)
                )}
          </SelectInput>
        </div>
        <div className="col-md-3 mt-3 col-xl-3 col-lg-3">
          <SelectInput
            name="isOd"
            value={isOd}
            required={true}
            textWhite={false}
            isLabeled={false}
            label="Select Od or not"
            onChange={(e) => setIsOd(e.target.value)}
          >
            <option value=""> Select Od or not</option>
            <option value={false}>NO</option>
            <option value={true}>YES</option>
          </SelectInput>
        </div>
        <div className="col-md-3 mt-3 col-xl-3 col-lg-3">
          <TextInput
            type="text"
            name="workerId"
            required={true}
            textWhite={false}
            htmlFor="workerId"
            label="Employee-Id"
            onChange={handleChange}
            value={attendanceData.workerId}
            placeholder="Enter Employee-Id"
            disabled={!isSuperAdmin(currentUser)}
          />
        </div>
      </div>
      <div className="row ">
        <div className="col-md-4 mt-3 col-xl-4 col-lg-4">
          <TextInput
            type="time"
            name="inTime"
            label="In-Time"
            required={true}
            htmlFor="inTime"
            textWhite={false}
            onChange={handleChange}
            placeholder="Enter In-Time"
            value={attendanceData.inTime}
          />
        </div>
        <div className="col-md-4 mt-3 col-xl-4 col-lg-4">
          <TextInput
            type="time"
            name="outTime"
            required={true}
            label="Out-Time"
            htmlFor="outTime"
            textWhite={false}
            onChange={handleChange}
            placeholder="Enter Out-Time"
            value={attendanceData.outTime}
          />
        </div>
        <div className="col-md-4 mt-3  col-xl-4 col-lg-4">
          <SelectInput
            name="status"
            required={false}
            textWhite={false}
            isLabeled={false}
            label="Select status"
            onChange={handleChange}
            value={attendanceData.status}
          >
            <option value="">Select status</option>
            <option value={CREATED_AS_TYPE.fullTime}>
              {CREATED_AS_TYPE.fullTime}
            </option>
            <option value={CREATED_AS_TYPE.privilegeLeave}>
              {CREATED_AS_TYPE.privilegeLeave}
            </option>
            <option value={CREATED_AS_TYPE.needBasedLeave}>
              {CREATED_AS_TYPE.needBasedLeave}
            </option>
            <option value={CREATED_AS_TYPE.paternityLeave}>
              {CREATED_AS_TYPE.paternityLeave}
            </option>
            <option value={CREATED_AS_TYPE.maternityLeave}>
              {CREATED_AS_TYPE.maternityLeave}
            </option>
            <option value={CREATED_AS_TYPE.bereavementLeave}>
              {CREATED_AS_TYPE.bereavementLeave}
            </option>
            <option value={CREATED_AS_TYPE.compensatoryOff}>
              {CREATED_AS_TYPE.compensatoryOff}
            </option>
            <option value={CREATED_AS_TYPE.optionalHoliday}>
              {CREATED_AS_TYPE.optionalHoliday}
            </option>
            <option value={CREATED_AS_TYPE.paidHoliday}>
              {CREATED_AS_TYPE.paidHoliday}
            </option>
            <option value={CREATED_AS_TYPE.accidentalLeave}>
              {CREATED_AS_TYPE.accidentalLeave}
            </option>
            <option value={CREATED_AS_TYPE.absent}>
              {CREATED_AS_TYPE.absent}
            </option>
            <option value={CREATED_AS_TYPE.weeklyOff}>
              {CREATED_AS_TYPE.weeklyOff}
            </option>
          </SelectInput>
        </div>
        <div className="col-md-5 mt-3 col-xl-5 col-lg-5">
          <TextArea
            row={4}
            type="text"
            name="remark"
            value={attendanceData.remark}
            required={true}
            htmlFor="remark"
            textWhite={false}
            label="Write a remark"
            placeholder="Enter a remark"
            onChange={handleChange}
          />
        </div>
        <div className="form-group text-center col-sm-2 mt-5 col-xl-2 col-lg-2">
          {attendanceLoading ? (
            <SpinnerButton />
          ) : (
            <Button
              type="submit"
              title="Submit"
              isBackgroundColor={false}
              icon="mdi mdi-plus-circle-outline mr-2"
              className="btn text-white btn-block btn-dark"
            />
          )}
        </div>
      </div>
    </form>
  );

  return (
    <Starter
      topBarTitle="Missing Attendance"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Attendance Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Attendance</a>
          </li>
          <li className="breadcrumb-item active">
            Single Missing Attendance
          </li>
        </Fragment>
      }
    >
      <div className="row">
        <div className="col-lg-12">
          <Card>
            <div className="row">
              <div className="col-lg-12">
                <Strong
                  title="All inputs are compulsory*"
                  className="text-danger float-right"
                />
                <HeaderTag
                  type="h4"
                  title="Add Missing Attendance"
                  isClassName={false}
                />
                <P title="Fill the form below to Missing Attendance" />
              </div>
            </div>
            {topInput}
          </Card>
        </div>
      </div>
    </Starter>
  );
}

export default SingleMissing;
